import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7346 17.3839H5.6763C2.71797 17.3839 1.66797 15.3089 1.66797 13.3755V6.62552C1.66797 3.74219 2.79297 2.61719 5.6763 2.61719H10.7346C13.618 2.61719 14.743 3.74219 14.743 6.62552V13.3755C14.743 16.2589 13.618 17.3839 10.7346 17.3839ZM5.6763 3.88385C3.5013 3.88385 2.93464 4.45052 2.93464 6.62552V13.3755C2.93464 14.4005 3.29297 16.1172 5.6763 16.1172H10.7346C12.9096 16.1172 13.4763 15.5505 13.4763 13.3755V6.62552C13.4763 4.45052 12.9096 3.88385 10.7346 3.88385H5.6763V3.88385Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3177 15.0911C16.9594 15.0911 16.501 14.9744 15.976 14.6078L13.751 13.0494C13.5844 12.9328 13.4844 12.7411 13.4844 12.5328V7.46609C13.4844 7.25776 13.5844 7.06609 13.751 6.94943L15.976 5.39109C16.9677 4.69943 17.6927 4.89943 18.0344 5.07443C18.376 5.25776 18.9594 5.73276 18.9594 6.94109V13.0494C18.9594 14.2578 18.376 14.7411 18.0344 14.9161C17.876 15.0078 17.626 15.0911 17.3177 15.0911ZM14.7427 12.1994L16.701 13.5661C17.076 13.8244 17.3427 13.8494 17.451 13.7911C17.5677 13.7328 17.6927 13.4994 17.6927 13.0494V6.94943C17.6927 6.49109 17.5594 6.26609 17.451 6.20776C17.3427 6.14943 17.076 6.17443 16.701 6.43276L14.7427 7.79943V12.1994Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.58203 9.78906C8.5487 9.78906 7.70703 8.9474 7.70703 7.91406C7.70703 6.88073 8.5487 6.03906 9.58203 6.03906C10.6154 6.03906 11.457 6.88073 11.457 7.91406C11.457 8.9474 10.6154 9.78906 9.58203 9.78906ZM9.58203 7.28906C9.24036 7.28906 8.95703 7.5724 8.95703 7.91406C8.95703 8.25573 9.24036 8.53906 9.58203 8.53906C9.9237 8.53906 10.207 8.25573 10.207 7.91406C10.207 7.5724 9.9237 7.28906 9.58203 7.28906Z",
			fill: "white"
		})
	]
});
export default SvgVideo;
